import { Component } from '@/lib/decorators/component';
import { RegionDefinition } from '@/lib/decorators/region-definition';
import { ProductTileCustom } from '@/components/product-tile-custom';

/* v8 ignore start - do not test decorators in unit tests, decorator functionality is tested separately */
@Component('productTile', {
    name: 'Product Tile',
    description: 'Eataly product tile (Figma design)',
    group: 'content',
})
@RegionDefinition([])
export class ProductTileMetadata {}
/* v8 ignore stop */

export { ProductTileCustom };
export type {
    ProductTileCustomProps,
    ProductTileCustomProps as ProductTileProps,
} from '@/components/product-tile-custom';

const ProductTile = ProductTileCustom;

export { ProductTile };
// eslint-disable-next-line react-refresh/only-export-components
export { ProductTileProvider, useProductTileContext } from './context';
export default ProductTile;
